export const sitemapHero = {
  title: 'サイトマップ',
  titleEn: 'SITEMAP',
  lead: 'お探しの情報に素早くたどり着けるよう、当サイトの全ページを区分ごとに一覧にまとめました。',
};

export interface SitemapSection {
  id: string;
  title: string;
  titleEn: string;
  description: string;
  links: { label: string; href: string }[];
}

export const sitemapSections: SitemapSection[] = [
  {
    id: 'about',
    title: 'アカデミーについて',
    titleEn: 'About the Academy',
    description: '日本執事アカデミーの概要、教育理念、運営体制、施設、アクセスについてご案内します。',
    links: [
      { label: '個人のお客様（通学型コース）', href: '/personal' },
      { label: 'アカデミー概要', href: '/about' },
      { label: '教育理念・方針', href: '/philosophy' },
      { label: '全日本執事協会について', href: '/association' },
      { label: '施設・設備紹介', href: '/facilities' },
      { label: 'アクセス', href: '/access' },
      { label: '学長挨拶', href: '/president' },
    ],
  },
  {
    id: 'courses',
    title: 'コース紹介',
    titleEn: 'Courses',
    description: '3つの本科コースと年間スケジュール。目的に合わせてお選びいただけます。',
    links: [
      { label: 'コース一覧・比較', href: '/courses' },
      { label: 'エッセンシャルコース', href: '/courses/essential' },
      { label: 'アドバンスコース', href: '/courses/advanced' },
      { label: 'マスターコース', href: '/courses/master' },
      { label: '年間スケジュール', href: '/schedule' },
    ],
  },
  {
    id: 'curriculum',
    title: 'カリキュラム',
    titleEn: 'Curriculum',
    description: '学びの全体像、実践トレーニング、教材、習得スキルについて詳しくご紹介します。',
    links: [
      { label: 'カリキュラム概要', href: '/curriculum' },
      { label: '実践トレーニング', href: '/training' },
      { label: '使用教材', href: '/materials' },
      { label: '習得スキル一覧', href: '/skills' },
    ],
  },
  {
    id: 'pricing',
    title: '料金・特典',
    titleEn: 'Pricing & Benefits',
    description: '受講料の内訳、各種特典、修了時に取得できる認定資格についてご確認いただけます。',
    links: [
      { label: '料金概要', href: '/pricing' },
      { label: 'コース別料金詳細', href: '/pricing/details' },
      { label: '受講特典', href: '/benefits' },
      { label: '修了証・認定資格について', href: '/certificate' },
    ],
  },
  {
    id: 'admission',
    title: '入学案内',
    titleEn: 'Admission',
    description: '入学の流れ、応募資格、申込手順、個別相談、体験講座についてご案内します。',
    links: [
      { label: '入学案内概要', href: '/admission' },
      { label: '応募資格・申込の流れ', href: '/application' },
      { label: '申込フォーム', href: '/apply' },
      { label: '個別相談予約', href: '/consultation' },
      { label: '体験講座', href: '/seminar' },
    ],
  },
  {
    id: 'contact',
    title: 'お問い合わせ',
    titleEn: 'Contact & More',
    description: '各種お問い合わせ窓口、よくある質問、資料請求、法人研修、ブログへのリンクです。',
    links: [
      { label: 'お問い合わせ', href: '/contact' },
      { label: 'よくある質問', href: '/faq' },
      { label: '資料請求', href: '/brochure' },
      { label: '法人研修', href: '/corporate' },
      { label: '講師ブログ', href: '/blog' },
    ],
  },
  {
    id: 'corporate',
    title: '法人研修（業種別）',
    titleEn: 'Corporate Training by Industry',
    description: '業種ごとの課題に合わせた、法人向け接遇・ビジネスマナー研修の各ページです。',
    links: [
      { label: 'ホテル・旅館', href: '/corporate/hotel' },
      { label: '高級レジデンス', href: '/corporate/residence' },
      { label: '金融・プライベートバンキング', href: '/corporate/finance' },
      { label: '百貨店外商・高級小売', href: '/corporate/retail' },
      { label: 'ラグジュアリー営業', href: '/corporate/luxury-sales' },
      { label: '医療・美容クリニック', href: '/corporate/clinic' },
      { label: '自動車・モビリティ', href: '/corporate/automotive' },
      { label: 'ハイヤー・送迎', href: '/corporate/chauffeur' },
    ],
  },
  {
    id: 'other',
    title: 'その他',
    titleEn: 'Other',
    description: 'お知らせやサイトのご利用に関するページです。',
    links: [
      { label: 'お知らせ', href: '/news' },
    ],
  },
];

export const sitemapFaqs = [
  {
    question: 'サイトマップとは何ですか?',
    answer: '当サイトの全ページへのリンクを一覧にまとめたページです。お探しの情報に素早くアクセスできます。',
  },
  {
    question: '法人研修のページはどこですか?',
    answer: '法人研修の総合ページと、8つの業種別ページへのリンクをこのサイトマップに掲載しています。',
  },
  {
    question: '見つからないページがあります',
    answer: 'サイト内検索またはお問い合わせよりお申し付けください。',
  },
];